module.exports = __webpack_public_path__ + "static/img/lj1.fb2ff0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj1.png
// module id = e4Jj
// module chunks = 3